import {MessageDescriptor} from '@lingui/core';
import {t} from '@lingui/macro';

/*
 * Types.
 */

export enum CsatEditorBaseErrorsEnum {
  INVALID_DELAY = 'INVALID_DELAY',
  INVALID_RESPONSE = 'INVALID_RESPONSE',
  INVALID_SCHEDULED_ACTION = 'INVALID_SCHEDULED_ACTION',
  INVALID_SENT_ACTION = 'INVALID_SENT_ACTION',
}

/*
 * Constants.
 */

export const csatEditorBaseErrorLabels: Record<CsatEditorBaseErrorsEnum, MessageDescriptor> = {
  [CsatEditorBaseErrorsEnum.INVALID_DELAY]: t(
    'csat-editor-footer-tooltip-warning-delay',
  )`Your delay is invalid`,
  [CsatEditorBaseErrorsEnum.INVALID_RESPONSE]: t(
    'csat-editor-footer-tooltip-warning-response',
  )`Your rule is missing a message template`,
  [CsatEditorBaseErrorsEnum.INVALID_SCHEDULED_ACTION]: t(
    'csat-editor-footer-tooltip-warning-scheduled-action',
  )`One of your scheduled actions is invalid`,
  [CsatEditorBaseErrorsEnum.INVALID_SENT_ACTION]: t(
    'csat-editor-footer-tooltip-warning-sent-action',
  )`One of your sent actions is invalid`,
};
